module.exports = __webpack_public_path__ + "static/11-02b101b4220c713533fea525b6c0e9f1.jpg";